import React from "react";

export default function Type2() {
  const service = [
    "BIM Modelling (A/S/MEPF)",
    "BIM Coordination (A/S/MEPF)",
    "BIM Family & Content Development",
    "Walk Through Presentation",
    "Schedules & Quantity Takeoff",
    "Drawing Generation (SD/CD/DD/GFC/As-Built/SEM)",
    "4D Construction Sequencing",
    "5D Cost Simulation",
    "Scan To BIM",
  ];

  return (
    <div>
      <ul className="flex flex-wrap content-center md:justify-center gap-8">
        {service.map((s, i) => {
          return (
            <li key={i} className="med-text font-semibold relative md:pr-12 pb-6 flex flex-col gap-3 md:w-fit w-full text-bright">
              {i+1}) {s}
              <div className="w-full h-[2px] bg-bright rounded-full" />
            </li>
          );
        })}
      </ul>
    </div>
  );
}
